import { MeetingServiceOrder } from "../../../../../../modules/merchant/accounting/accounting/accountingTypes"

export function getFirstOrderNote(deliveries?: MeetingServiceOrder["deliveries"]) {
    return deliveries?.find((d) => typeof d?.orderNote === "string" && d.orderNote.trim().length > 0)?.orderNote ?? ""
}
